.wrapper {
  padding: 32px 16px 64px;
  max-width: 350px;
  margin: 0 auto;
  text-align: center;
}

.wrapper p {
  font-size: 0.75rem;
  opacity: 0.5;
  color: white;
}

.wrapper p:not(:last-of-type) {
  margin-bottom: 1em;
}
